export const year = (year, className) =>
  `<div class="${className}">${year}</div>`;
